/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dynamic-input.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/forms';
import * as i5 from '@covalent/dynamic-forms/dynamic-elements/dynamic-input/dynamic-input.component';
import * as i6 from '@angular/common';
const styles_TdDynamicInputComponent:any[] = [i0.styles];
export const RenderType_TdDynamicInputComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdDynamicInputComponent,data:{}});
function View_TdDynamicInputComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['Max: ','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.max;
    _ck(_v,1,0,currVal_0);
  });
}
function View_TdDynamicInputComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['Min: ','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.min;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_TdDynamicInputComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),35,'div',[['class',
      'dynamic-input-wrapper'],['layout','column']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),32,'md-input-container',([] as any[]),
          [[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,3)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i4.NgForm],
          [2,i4.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),i1.ɵqud(603979776,
      3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),i1.ɵqud(603979776,
      5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),(_l()(),i1.ɵted(1,
      ['\n    '])),(_l()(),i1.ɵeld(0,[['elementInput',1]],1,8,'input',[['flex',''],
      ['mdInput','']],[[1,'min',0],[1,'max',0],[1,'required',0],[2,'ng-untouched',
      (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
      [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
      [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],[8,'id',
          0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',
          0]],[[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
      'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
      [(null as any),'focus']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i5.TdDynamicInputComponent = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,12)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,12).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,12)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,12)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>i1.ɵnov(_v,19)._onBlur()) !== false);
      ad = (pd_4 && ad);
    }
    if (('focus' === en)) {
      const pd_5:any = ((<any>i1.ɵnov(_v,19)._onFocus()) !== false);
      ad = (pd_5 && ad);
    }
    if (('input' === en)) {
      const pd_6:any = ((<any>i1.ɵnov(_v,19)._onInput()) !== false);
      ad = (pd_6 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_7:any = ((<any>(_co.value = $event)) !== false);
      ad = (pd_7 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i4.RequiredValidator,([] as any[]),{required:[0,
          'required']},(null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i4.RequiredValidator]),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,
          (null as any)],[2,i4.NG_VALIDATORS],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i4.NgControl,(null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[1,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,'placeholder'],
              required:[1,'required'],type:[2,'type']},(null as any)),(_l()(),i1.ɵted(1,
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),5,12,'md-hint',[['align','start']],
          [[2,'mat-hint',(null as any)],[2,'mat-right',(null as any)],[1,'id',0]],
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
          [[4,4]],0,i3.MdHint,([] as any[]),{align:[0,'align']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'span',[['class',
          'tc-red-600']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TdDynamicInputComponent_1)),i1.ɵdid(16384,
          (null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_TdDynamicInputComponent_2)),
      i1.ɵdid(16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),
          i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted(1,['\n  '])),(_l()(),
          i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i5.TdDynamicInputComponent = _v.component;
    const currVal_27:any = _co.required;
    _ck(_v,13,0,currVal_27);
    const currVal_28:any = _co.value;
    _ck(_v,16,0,currVal_28);
    const currVal_29:any = _co.label;
    const currVal_30:any = _co.required;
    const currVal_31:any = _co.type;
    _ck(_v,19,0,currVal_29,currVal_30,currVal_31);
    const currVal_35:any = 'start';
    _ck(_v,22,0,currVal_35);
    const currVal_36:any = _co.control.hasError('max');
    _ck(_v,28,0,currVal_36);
    const currVal_37:any = _co.control.hasError('min');
    _ck(_v,31,0,currVal_37);
  },(_ck,_v) => {
    var _co:i5.TdDynamicInputComponent = _v.component;
    const currVal_0:any = (null as any);
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,3)._isErrorState();
    const currVal_3:any = i1.ɵnov(_v,3)._mdInputChild.focused;
    const currVal_4:any = i1.ɵnov(_v,3)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,3)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,3)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,3)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,3)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,3)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,3)._shouldForward('pending');
    _ck(_v,2,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10]);
    const currVal_11:any = _co.min;
    const currVal_12:any = _co.max;
    const currVal_13:any = (i1.ɵnov(_v,13).required? '': (null as any));
    const currVal_14:any = i1.ɵnov(_v,18).ngClassUntouched;
    const currVal_15:any = i1.ɵnov(_v,18).ngClassTouched;
    const currVal_16:any = i1.ɵnov(_v,18).ngClassPristine;
    const currVal_17:any = i1.ɵnov(_v,18).ngClassDirty;
    const currVal_18:any = i1.ɵnov(_v,18).ngClassValid;
    const currVal_19:any = i1.ɵnov(_v,18).ngClassInvalid;
    const currVal_20:any = i1.ɵnov(_v,18).ngClassPending;
    const currVal_21:any = true;
    const currVal_22:any = i1.ɵnov(_v,19).id;
    const currVal_23:any = i1.ɵnov(_v,19).placeholder;
    const currVal_24:any = i1.ɵnov(_v,19).disabled;
    const currVal_25:any = i1.ɵnov(_v,19).required;
    const currVal_26:any = (i1.ɵnov(_v,19).ariaDescribedby || (null as any));
    _ck(_v,11,1,[currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,
        currVal_24,currVal_25,currVal_26]);
    const currVal_32:any = true;
    const currVal_33:any = (i1.ɵnov(_v,22).align == 'end');
    const currVal_34:any = i1.ɵnov(_v,22).id;
    _ck(_v,21,0,currVal_32,currVal_33,currVal_34);
  });
}
export function View_TdDynamicInputComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-dynamic-input',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdDynamicInputComponent_0,
      RenderType_TdDynamicInputComponent)),i1.ɵprd(5120,(null as any),i4.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i5.TdDynamicInputComponent]),i1.ɵdid(49152,(null as any),0,i5.TdDynamicInputComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const TdDynamicInputComponentNgFactory:i1.ComponentFactory<i5.TdDynamicInputComponent> = i1.ɵccf('td-dynamic-input',
    i5.TdDynamicInputComponent,View_TdDynamicInputComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/dynamic-forms/dynamic-elements/dynamic-input/dynamic-input.component.ngfactory.ts